import type { Block, ParagraphData } from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";
import "./subStep.css";

export default function SubStepView({
  block,
  subStepLabel = "a.",
}: {
  block: Block;
  subStepLabel?: string;
}) {
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-substep">
      <span className="pdf-substep__num">{subStepLabel}</span>

      <span className="pdf-substep__text">
        {(data.textParts || []).map((part, i) => {
          if (part.type === "text") return <span key={i}>{part.value}</span>;

          return (
            <RefLink
              key={i}
              targetId={part.targetId}
              label={part.label}
              className="pdf-ref-link text-primary"
            />
          );
        })}
      </span>
    </div>
  );
}
